module.exports = __webpack_public_path__ + "img/zheng.5b3e70dc.png";